module.exports = __webpack_public_path__ + "img/20.1fc9b293.png";